// @flow

import type {PhotoEBadgeQueryFailedAction, PhotoEBadgeQueryStartAction, PhotoEBadgeQuerySuccessAction} from "../photoEBadgeQueryAction";
import type {PhotoEBadgeSearchCriteria} from "../../../../components/ebadge/photo/PhotoEBadgeSearchForm";
import {findPhotoEBadgeByCriteria} from "../../../../dao/eBadgeDao";
import type {StoreState} from "../../../../reducers/combinedReducers";
import {Dispatch} from "redux";
import type {PhotoEBadge, PhotoEBadgeQueryResultType} from "../../../../components/ebadge/photo/PhotoEBadgeQueryResult";
import {ThunkAction} from "redux-thunk";
import moment from "moment";
import {xand} from "../../../../helpers/utils";


export function photoEBadgeQueryStartAction(criteria: PhotoEBadgeSearchCriteria): PhotoEBadgeQueryStartAction {
    return {
        type: "ebadge/photo/QUERY_START_ACTION",
        criteria
    };
}

export function photoEBadgeQuerySuccessAction(eBadges: Array<PhotoEBadge>, totalResult: number): PhotoEBadgeQuerySuccessAction {
    return {
        type: "ebadge/photo/QUERY_SUCCESS_ACTION",
        eBadges,
        totalResult
    }
}

function photoEBadgeQueryFailedAction(error: any): PhotoEBadgeQueryFailedAction {
    return {
        type: "ebadge/photo/QUERY_FAILED_ACTION",
        error
    }
}


export function photoEBadgeQueryAction(criteria: PhotoEBadgeSearchCriteria): ThunkAction {

    return async (dispatch: Dispatch, getState: ?() => StoreState) => {

        try {
            if (!(criteria.toSerial) &&
                !(criteria.fromSerial) &&
                !(criteria.registrationCode) &&
                !(criteria.fromDate && criteria.toDate) &&
                !(criteria.year && criteria.projectCode)
                ) {

                throw new Error(`Please fill in one of the below:
                                <ol style="list-style-type: upper-alpha">
                                <li>VMS Registration Number</li>
                                <li>Year with Fair</li>
                                <li>Date range</li>
                                <li>VMS Serial Number</li>
                                </ol>`);
            } else if (criteria.fromDate && criteria.toDate) {

                if (moment(criteria.fromDate, "YYYY-MM-DD HH:mm:ss").isSameOrAfter(moment(criteria.toDate, "YYYY-MM-DD HH:mm:ss"))) {
                    throw new Error("Your start date is later than your end date.");
                }
            }

            if (!xand(criteria.fromDate, criteria.toDate)) {

                throw new Error("Please fill in both from and to for Date range, or remove this criteria");
            }

            if (moment(criteria.fromModifiedDate, "YYYY-MM-DD HH:mm:ss").isSameOrAfter(moment(criteria.toModifiedDate, "YYYY-MM-DD HH:mm:ss"))) {
                throw new Error("Your photo modified start date is later than your end date.");
            }

            if (!xand(criteria.fromModifiedDate, criteria.toModifiedDate)) {

                throw new Error("Please fill in both from and to for Photo Modified Date range, or remove this criteria");
            }

            if (getState) {
                dispatch(photoEBadgeQueryStartAction(criteria));
                let result: PhotoEBadgeQueryResultType = await findPhotoEBadgeByCriteria(criteria, getState().loginUser.jwt);
                dispatch(photoEBadgeQuerySuccessAction(result.list, result.totalResult));
            } else {
                throw new Error("Unexpected Error");
            }
        } catch (e) {

            dispatch(photoEBadgeQueryFailedAction(e));
        }

    };
}


// WEBPACK FOOTER //
// ./src/actions/ebadge/photo/creators/photoEBadgeQueryActionCreator.js